// import React, { useState } from "react";
// import { Chart } from "react-google-charts";

// export default function DynamicPieChartWithStyledTable({
//   dataList,
//   labelField,
//   chartTitle,
//   width,
//   height,
// }) {
//   const [hoveredTopic, setHoveredTopic] = useState(null);

//   const chartData = [
//     ["Topic", "Questions"],
//     ...dataList.map((topic) => [
//       topic[labelField],
//       topic.easy + topic.medium + topic.tough,
//     ]),
//   ];

//   const chartEvents = [
//     {
//       eventName: "onmouseover",
//       callback: ({ eventArgs }) => {
//         if (eventArgs.row !== null) setHoveredTopic(dataList[eventArgs.row]);
//       },
//     },
//     {
//       eventName: "onmouseout",
//       callback: () => setHoveredTopic(null),
//     },
//   ];

//   const renderInfoBox = () => {
//     if (!hoveredTopic) return null;
//     const difficultyData = [
//       { level: "Low", value: hoveredTopic.easy },
//       { level: "Medium", value: hoveredTopic.medium },
//       { level: "High", value: hoveredTopic.tough },
//     ];
//     return (
//       <div
//         style={{
//           position: "absolute",
//           background: "#f6f7fa",
//           border: "1px solid #a4c2f4",
//           borderRadius: 8,
//           minWidth: 180,
//           top: 100,
//           left: 400,
//           zIndex: 100,
//           boxShadow: "0 4px 12px rgba(90,120,180,0.15)",
//           fontFamily: "Segoe UI, Arial, sans-serif",
//         }}
//       >
//         <div
//           style={{
//             background: "#4791db",
//             color: "#fff",
//             fontWeight: 600,
//             fontSize: 16,
//             padding: "8px 16px",
//             borderTopLeftRadius: 8,
//             borderTopRightRadius: 8,
//             borderBottom: "1px solid #a4c2f4",
//             textAlign: "left",
//           }}
//         >
//           Difficulty Level
//         </div>
//         {difficultyData.map((row, idx) => (
//           <div
//             key={row.level}
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               padding: "8px 16px",
//               background: idx === 0 ? "#e3edfa" : "#f6f7fa",
//               borderBottom:
//                 idx < difficultyData.length - 1 ? "1px solid #dbe9f8" : "none",
//               fontSize: 15,
//             }}
//           >
//             <span style={{ color: "#375a7f" }}>{row.level}</span>
//             <span style={{ fontWeight: 600 }}>{row.value}</span>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div style={{ position: "relative", minHeight: height }}>
//       <Chart
//         chartType="PieChart"
//         width={width}
//         height={height}
//         data={chartData}
//         options={{ title: chartTitle, is3D: true }}
//         chartEvents={chartEvents}
//       />
//       {renderInfoBox()}
//     </div>
//   );
// }

// import React from "react";
// import { Chart } from "react-google-charts";
// import Colors from "../../Constants/Colors";
// import "../OneComponent.css";
// function getTooltipHTML(
//   item,
//   labelField,
//   allFields,
//   tooltipHeader,
//   pieType,
//   otherData
// ) {
//   // Generic table section creator
//   const createTableSection = (title, data, type) => {
//     if (!data || !Array.isArray(data)) return "";

//     let rows;
//     switch (type) {
//       case "topics":
//         rows = data.map((topic, idx) => ({
//           label: topic.topic_name,
//           value: topic.count,
//         }));
//         break;
//       case "difficulty":
//         rows = ["Easy", "Medium", "Tough"].map((level) => ({
//           label: level,
//           value: data.find((d) => d.difficulty === level)?.count || 0,
//         }));
//         break;
//       case "questionType":
//         rows = data.map((type, idx) => ({
//           label: type.question_type,
//           value: type.count,
//         }));
//         break;
//       default:
//         return "";
//     }

//     return `
//       <div style="margin-top: 10px;">
//         <div style="
//           background: ${Colors.color12};
//           color: ${Colors.color14};
//           font-weight: 700;
//           font-size: 16px;
//           padding: 6px 0 6px 14px;
//           text-align: center;
//           letter-spacing: .2px;
//         ">
//           ${title}
//         </div>
//         <div style="padding: 0;">
//           ${rows
//             .map(
//               (row, idx) => `
//             <div style="
//               display: flex;
//               justify-content: space-between;
//               align-items: center;
//               background: ${idx % 2 === 0 ? Colors.color13 : Colors.color14};
//               padding: 7px 14px;
//               font-size: 14px;
//               font-weight: 500;
//             ">
//               <span>${row.label}</span>
//               <span style="font-weight: 400; font-size: 16px;">
//                 ${row.value}
//               </span>
//             </div>
//           `
//             )
//             .join("")}
//         </div>
//       </div>
//     `;
//   };

//   // Determine which tables to show based on pie type
//   const getAdditionalTables = () => {
//     switch (pieType) {
//       case "topics":
//         return `
//           ${createTableSection(
//             "Difficulty Level",
//             otherData.difficultyData,
//             "difficulty"
//           )}
//           ${createTableSection(
//             "Question Types",
//             otherData.questionTypeData,
//             "questionType"
//           )}
//         `;
//       case "difficulty":
//         return `
//           ${createTableSection("Topics", otherData.topicData, "topics")}
//           ${createTableSection(
//             "Question Types",
//             otherData.questionTypeData,
//             "questionType"
//           )}
//         `;
//       case "questionType":
//         return `
//           ${createTableSection("Topics", otherData.topicData, "topics")}
//           ${createTableSection(
//             "Difficulty Level",
//             otherData.difficultyData,
//             "difficulty"
//           )}
//         `;
//       default:
//         return "";
//     }
//   };

//   return `
//     <div style="
//       width: 100% !important;
//       min-width: 250px;
//       font-family: 'Segoe UI', Arial, sans-serif;
//       font-size: 15px;
//       color: ${Colors.color1};
//       border-radius: 4px;
//       overflow: hidden;
//       border: 1px solid ${Colors.color11};
//       transform: translate(90px, 12px);
//       pointer-events: none;
//       background-clip: padding-box;
//       box-shadow: none;
//       margin: 0;
//       background: white;
//     ">
//       <div style="
//         background: ${Colors.color12};
//         color: ${Colors.color14};
//         font-weight: 700;
//         font-size: 16px;
//         padding: 8px 14px;
//         text-align: left;
//       ">
//         ${item[labelField]}
//       </div>
//       <div style="
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         padding: 8px 14px;
//         background: ${Colors.color13};
//       ">
//         <span>Total Questions</span>
//         <span style="font-weight: 600;">${item[allFields[0]]}</span>
//       </div>
//       ${getAdditionalTables()}
//     </div>
//   `;
// }

// export default function DynamicPieChart({
//   dataList,
//   labelField,
//   chartTitle = "Pie Chart",
//   width = "800px",
//   height = "600px",
//   onSliceSelect,
//   pieType,
//   topicData,
//   difficultyData,
//   questionTypeData,
//   tooltipHeader,
// }) {
//   if (!Array.isArray(dataList) || dataList.length === 0)
//     return <div>No data to display</div>;

//   const allFields = Object.keys(dataList[0]).filter(
//     (k) => k !== labelField && typeof dataList[0][k] !== "object"
//   );

//   const valueField = allFields.find(
//     (k) => typeof dataList[0][k] === "number" && !isNaN(dataList[0][k])
//   );

//   if (!valueField) return <div>No numeric field found for pie values.</div>;

//   const chartData = [
//     ["Label", "Value", { role: "tooltip", type: "string", p: { html: true } }],
//     ...dataList.map((item) => [
//       item[labelField],
//       Number(item[valueField]),
//       getTooltipHTML(item, labelField, allFields, tooltipHeader, pieType, {
//         topicData,
//         difficultyData,
//         questionTypeData,
//       }),
//     ]),
//   ];

//   const options = {
//     title: chartTitle,
//     is3D: true,
//     tooltip: {
//       isHtml: true,
//       trigger: "hover",
//     },
//     legend: {
//       position: "right",
//       textStyle: { fontSize: 14 },
//     },
//     chartArea: {
//       left: 20,
//       top: 20,
//       width: "85%",
//       height: "80%",
//     },
//     fontName: "Segoe UI, Arial, sans-serif",
//     backgroundColor: "transparent",
//   };

//   return (
//     <Chart
//       chartType="PieChart"
//       width={width}
//       height={height}
//       data={chartData}
//       options={options}
//     />
//   );
// }

// import React from "react";
// import { Chart } from "react-google-charts";
// import Colors from "../../Constants/Colors";
// import "../OneComponent.css";
// function getTooltipHTML(item, labelField, allFields, tooltipHeader, pieType, otherData) {
//   // Generic table creator with positioning
//   const createTableSection = (title, data, type, position) => {
//     if (!data || !Array.isArray(data)) return "";

//     let rows;
//     switch (type) {
//       case "topics":
//         rows = data.map((topic) => ({
//           label: topic.topic_name,
//           value: topic.count,
//         }));
//         break;
//       case "difficulty":
//         rows = ["Easy", "Medium", "Tough"].map((level) => ({
//           label: level,
//           value: data.find((d) => d.difficulty === level)?.count || 0,
//         }));
//         break;
//       case "questionType":
//         rows = data.map((type) => ({
//           label: type.question_type,
//           value: type.count,
//         }));
//         break;
//       default:
//         return "";
//     }

//     const positionStyles = {
//       primary: "transform: translate(90px, 12px);",
//       secondary: "transform: translate(380px, 12px);",
//       tertiary: "transform: translate(670px, 12px);",
//     };

//     return `
//       <div style="
//         position: absolute;
//         ${positionStyles[position]};
//         width: 280px !important;
//         min-width: 280px;
//         font-family: 'Segoe UI', Arial, sans-serif;
//         font-size: 15px;
//         color: ${Colors.color1};
//         border-radius: 4px;
//         overflow: hidden;
//         border: 1px solid ${Colors.color11};
//         pointer-events: none;
//         background-clip: padding-box;
//         box-shadow: 0 2px 8px rgba(0,0,0,0.15);
//         margin: 0;
//         background: white;
//         z-index: 9999;
//       ">
//         <div style="
//           background: ${Colors.color12};
//           color: ${Colors.color14};
//           font-weight: 700;
//           font-size: 16px;
//           padding: 8px 14px;
//           text-align: left;
//         ">
//           ${title}
//         </div>
//         <div style="padding: 0;">
//           ${rows.map((row, idx) => `
//             <div style="
//               display: flex;
//               justify-content: space-between;
//               align-items: center;
//               background: ${idx % 2 === 0 ? Colors.color13 : Colors.color14};
//               padding: 7px 14px;
//               font-size: 14px;
//               font-weight: 500;
//             ">
//               <span>${row.label}</span>
//               <span style="font-weight: 400; font-size: 16px;">${row.value}</span>
//             </div>
//           `).join("")}
//         </div>
//       </div>
//     `;
//   };

//   // Create different table layouts based on pie type
//   const getTables = () => {
//     switch (pieType) {
//       case "topics":
//         return `
//           ${createTableSection("Topic Details", [{ topic_name: item[labelField], count: item[allFields[0]] }], "topics", "primary")}
//           ${createTableSection("Difficulty Level", otherData.difficultyData, "difficulty", "secondary")}
//           ${createTableSection("Question Types", otherData.questionTypeData, "questionType", "tertiary")}
//         `;
//       case "difficulty":
//         return `
//           ${createTableSection("Difficulty Details", [{ difficulty: item[labelField], count: item[allFields[0]] }], "difficulty", "primary")}
//           ${createTableSection("Topics", otherData.topicData, "topics", "secondary")}
//           ${createTableSection("Question Types", otherData.questionTypeData, "questionType", "tertiary")}
//         `;
//       case "questionType":
//         return `
//           ${createTableSection("Question Type Details", [{ question_type: item[labelField], count: item[allFields[0]] }], "questionType", "primary")}
//           ${createTableSection("Topics", otherData.topicData, "topics", "secondary")}
//           ${createTableSection("Difficulty Level", otherData.difficultyData, "difficulty", "tertiary")}
//         `;
//       default:
//         return "";
//     }
//   };

//   return `<div style="position: relative;">${getTables()}</div>`;
// }

// export default function DynamicPieChart({
//   dataList,
//   labelField,
//   chartTitle = "Pie Chart",
//   width = "800px",
//   height = "600px",
//   onSliceSelect,
//   pieType,
//   topicData,
//   difficultyData,
//   questionTypeData,
//   tooltipHeader,
// }) {
//   if (!Array.isArray(dataList) || dataList.length === 0)
//     return <div>No data to display</div>;

//   const allFields = Object.keys(dataList[0]).filter(
//     (k) => k !== labelField && typeof dataList[0][k] !== "object"
//   );

//   const valueField = allFields.find(
//     (k) => typeof dataList[0][k] === "number" && !isNaN(dataList[0][k])
//   );

//   if (!valueField) return <div>No numeric field found for pie values.</div>;

//   const chartData = [
//     ["Label", "Value", { role: "tooltip", type: "string", p: { html: true } }],
//     ...dataList.map((item) => [
//       item[labelField],
//       Number(item[valueField]),
//       getTooltipHTML(item, labelField, allFields, tooltipHeader, pieType, {
//         topicData,
//         difficultyData,
//         questionTypeData,
//       }),
//     ]),
//   ];

//   const options = {
//     title: chartTitle,
//     is3D: true,
//     tooltip: {
//       isHtml: true,
//       trigger: "hover",
//     },
//     legend: {
//       position: "right",
//       textStyle: { fontSize: 14 },
//     },
//     chartArea: {
//       left: 20,
//       top: 20,
//       width: "85%",
//       height: "80%",
//     },
//     fontName: "Segoe UI, Arial, sans-serif",
//     backgroundColor: "transparent",
//   };

//   return (
//     <Chart
//       chartType="PieChart"
//       width={width}
//       height={height}
//       data={chartData}
//       options={options}
//     />
//   );
// }



// import React from "react";
// import { Chart } from "react-google-charts";
// import Colors from "../../Constants/Colors";
// import "../OneComponent.css";

// function getTooltipHTML(item, labelField, allFields, tooltipHeader, pieType, otherData) {
//   // Generic table creator with positioning
//   const createTableSection = (title, data, type, position) => {
//     if (!data || !Array.isArray(data)) return "";

//     let rows;
//     switch (type) {
//       case "topics":
//         rows = data.map((topic) => ({
//           label: topic.topic_name,
//           value: topic.count,
//         }));
//         break;
//       case "difficulty":
//         rows = ["Easy", "Medium", "Tough"].map((level) => ({
//           label: level,
//           value: data.find((d) => d.difficulty === level)?.count || 0,
//         }));
//         break;
//       case "questionType":
//         rows = data.map((type) => ({
//           label: type.question_type,
//           value: type.count,
//         }));
//         break;
//       default:
//         return "";
//     }

//     const positionStyles = {
//       primary: "transform: translate(90px, 12px);",
//       secondary: "transform: translate(380px, 12px);",
//       tertiary: "transform: translate(670px, 12px);",
//       // New left-side positions for questionType
//       leftPrimary: "transform: translate(-490px, 12px);",
//       leftSecondary: "transform: translate(-780px, 12px);",
//     };

//     return `
//       <div style="
//         position: absolute;
//         ${positionStyles[position]};
//         width: 280px !important;
//         min-width: 280px;
//         font-family: 'Segoe UI', Arial, sans-serif;
//         font-size: 15px;
//         color: ${Colors.color1};
//         border-radius: 4px;
//         overflow: hidden;
//         border: 1px solid ${Colors.color11};
//         pointer-events: none;
//         background-clip: padding-box;
//         box-shadow: 0 2px 8px rgba(0,0,0,0.15);
//         margin: 0;
//         background: white;
//         z-index: 9999;
//       ">
//         <div style="
//           background: ${Colors.color12};
//           color: ${Colors.color14};
//           font-weight: 700;
//           font-size: 16px;
//           padding: 8px 14px;
//           text-align: left;
//         ">
//           ${title}
//         </div>
//         <div style="padding: 0;">
//           ${rows.map((row, idx) => `
//             <div style="
//               display: flex;
//               justify-content: space-between;
//               align-items: center;
//               background: ${idx % 2 === 0 ? Colors.color13 : Colors.color14};
//               padding: 7px 14px;
//               font-size: 14px;
//               font-weight: 500;
//             ">
//               <span>${row.label}</span>
//               <span style="font-weight: 400; font-size: 16px;">${row.value}</span>
//             </div>
//           `).join("")}
//         </div>
//       </div>
//     `;
//   };

//   // Create different table layouts based on pie type - EXCLUDING the current pie chart's data table
//   const getTables = () => {
//     switch (pieType) {
//       case "topics":
//         return `
//           ${createTableSection("Difficulty Level", otherData.difficultyData, "difficulty", "primary")}
//           ${createTableSection("Question Types", otherData.questionTypeData, "questionType", "secondary")}
//         `;
//       case "difficulty":
//         return `
//           ${createTableSection("Topics", otherData.topicData, "topics", "primary")}
//           ${createTableSection("Question Types", otherData.questionTypeData, "questionType", "secondary")}
//         `;
//       case "questionType":
//         // Mirror tables to the left side for questionType
//         return `
//           ${createTableSection("Topics", otherData.topicData, "topics", "leftPrimary")}
//           ${createTableSection("Difficulty Level", otherData.difficultyData, "difficulty", "leftSecondary")}
//         `;
//       default:
//         return "";
//     }
//   };

//   return `<div style="position: relative;">${getTables()}</div>`;
// }

// export default function DynamicPieChart({
//   dataList,
//   labelField,
//   chartTitle = "Pie Chart",
//   width = "400px",
//   height = "300px",
//   onSliceSelect,
//   pieType,
//   topicData,
//   difficultyData,
//   questionTypeData,
//   tooltipHeader,
// }) {
//   if (!Array.isArray(dataList) || dataList.length === 0)
//     return <div>No data to display</div>;

//   const allFields = Object.keys(dataList[0]).filter(
//     (k) => k !== labelField && typeof dataList[0][k] !== "object"
//   );

//   const valueField = allFields.find(
//     (k) => typeof dataList[0][k] === "number" && !isNaN(dataList[0][k])
//   );

//   if (!valueField) return <div>No numeric field found for pie values.</div>;

//   const chartData = [
//     ["Label", "Value", { role: "tooltip", type: "string", p: { html: true } }],
//     ...dataList.map((item) => [
//       item[labelField],
//       Number(item[valueField]),
//       getTooltipHTML(item, labelField, allFields, tooltipHeader, pieType, {
//         topicData,
//         difficultyData,
//         questionTypeData,
//       }),
//     ]),
//   ];

//   const options = {
    
//     is3D: true,
//     tooltip: {
//       isHtml: true,
//       trigger: "hover",
//     },
//     legend: {
//       position: "right",
//       textStyle: { fontSize: 14 },
//     },
//     chartArea: {
//       left: 20,
//       top: 20,
//       width: "100%",
//       height: "100%",
//     },
//     fontName: "Segoe UI, Arial, sans-serif",
//     backgroundColor: "transparent",
//   };

//   return (
//      <div className="pie-chart-container">
//     <Chart
//       chartType="PieChart"
//       width={width}
//       height={height}
//       data={chartData}
//       options={options}
//     />
//     <div className="chart-title-bottom">
//       {chartTitle}
//     </div>
//   </div>
//   );
// }



import React, { useState } from "react";
import { Chart } from "react-google-charts";
import Colors from "../../Constants/Colors";
import "../OneComponent.css";

// Simplified tooltip - just show the slice info
function getSimpleTooltipHTML(item, labelField, valueField) {
  return `
    <div style="
      padding: 8px 12px;
      font-family: 'Segoe UI', Arial, sans-serif;
      font-size: 14px;
      color: ${Colors.color1};
      background: white;
      border-radius: 4px;
      border: 1px solid ${Colors.color11};
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    ">
      <strong>${item[labelField]}</strong><br/>
      Count: ${item[valueField]}
    </div>
  `;
}

// Static table component
function StaticDataTable({ title, data, type }) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="data-table">
        <h4 className="table-title">{title}</h4>
        <div className="no-data">No data available</div>
      </div>
    );
  }

  let rows;
  switch (type) {
    case "topics":
      rows = data.map((topic) => ({
        label: topic.topic_name,
        value: topic.count,
      }));
      break;
    case "difficulty":
      rows = ["Easy", "Medium", "Tough"].map((level) => ({
        label: level,
        value: data.find((d) => d.difficulty === level)?.count || 0,
      }));
      break;
    case "questionType":
      rows = data.map((type) => ({
        label: type.question_type,
        value: type.count,
      }));
      break;
    default:
      return null;
  }

  return (
    <div className="data-table">
      <h4 className="table-title">{title}</h4>
      <div className="table-content">
        {rows.map((row, idx) => (
          <div 
            key={idx}
            className={`table-row ${idx % 2 === 0 ? 'even' : 'odd'}`}
          >
            <span className="table-label">{row.label}</span>
            <span className="table-value">{row.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function DynamicPieChart({
  dataList,
  labelField,
  chartTitle = "Pie Chart",
  width = "400px",
  height = "300px",
  onSliceSelect,
  pieType,
  topicData,
  difficultyData,
  questionTypeData,
  tooltipHeader,
}) {
  // State to track hover status
  const [isChartHovered, setIsChartHovered] = useState(false);

  if (!Array.isArray(dataList) || dataList.length === 0)
    return <div>No data to display</div>;

  const allFields = Object.keys(dataList[0]).filter(
    (k) => k !== labelField && typeof dataList[0][k] !== "object"
  );

  const valueField = allFields.find(
    (k) => typeof dataList[0][k] === "number" && !isNaN(dataList[0][k])
  );

  if (!valueField) return <div>No numeric field found for pie values.</div>;

  const chartData = [
    ["Label", "Value", { role: "tooltip", type: "string", p: { html: true } }],
    ...dataList.map((item) => [
      item[labelField],
      Number(item[valueField]),
      getSimpleTooltipHTML(item, labelField, valueField),
    ]),
  ];

  const options = {
    is3D: true,
    tooltip: {
      isHtml: true,
      trigger: "hover",
    },
    legend: {
      position: "right",
      textStyle: { fontSize: 12 },
    },
    chartArea: {
      left: 20,
      
      width: "100%",
      height: "100%",
    },
    fontName: "Segoe UI, Arial, sans-serif",
    backgroundColor: "transparent",
  };

  // Function to determine which tables to show based on pie type
  const getTablesToShow = () => {
    switch (pieType) {
      case "topics":
        return [
          { title: "Difficulty Level", data: difficultyData, type: "difficulty" },
          { title: "Question Types", data: questionTypeData, type: "questionType" }
        ];
      case "difficulty":
        return [
          { title: "Topics", data: topicData, type: "topics" },
          { title: "Question Types", data: questionTypeData, type: "questionType" }
        ];
      case "questionType":
        return [
          { title: "Topics", data: topicData, type: "topics" },
          { title: "Difficulty Level", data: difficultyData, type: "difficulty" }
        ];
      default:
        return [
          { title: "Topics", data: topicData, type: "topics" },
          { title: "Difficulty Level", data: difficultyData, type: "difficulty" },
          { title: "Question Types", data: questionTypeData, type: "questionType" }
        ];
    }
  };

  const tablesToShow = getTablesToShow();

  return (
    <div className="pie-chart-container">
      {/* Chart with hover handlers */}
      <div 
        className="chart-wrapper"
        onMouseEnter={() => setIsChartHovered(true)}
        onMouseLeave={() => setIsChartHovered(false)}
      >
        <Chart
          chartType="PieChart"
          width={width}
          height={height}
          data={chartData}
          options={options}
        />
      </div>
      
      {/* Chart Title */}
      <div className="chart-title-bottom">
        {chartTitle}
      </div>

      {/* Static Data Tables - Only show when hovering over chart */}
      {isChartHovered && (
        <div className="data-tables-container data-tables-visible">
          {tablesToShow.map((table, index) => (
            <StaticDataTable 
              key={index}
              title={table.title} 
              data={table.data} 
              type={table.type} 
            />
          ))}
        </div>
      )}
    </div>
  );
}
